import axios from 'axios'
import { ENDPOINTS_CLASSROOM } from './urls'
import { ENDPOINTS_RESULTS } from 'api/results/urls'
import { autoReplace, checkError, dateToTimestamp } from 'utils'
import { EMPTY_STRING } from 'utils/constants'

export const updateResultGrade = async ({
  additioOrigin = true,
  questionId,
  resultId,
  teacherGrade,
  userBookId,
}) => {
  const url = ENDPOINTS_RESULTS.RESULTS
  const sendData = {
    additioOrigin,
    questionId,
    teacherGrade,
    userBookId,
  }
  if (additioOrigin) {
    sendData.resultId = resultId
  }
  const { data } = await axios.post(url, {
    ...sendData,
  })
  return data
}

export const getClassroomMaterials = async ({ classId, userId }) => {
  const correction = {
    [':classId']: classId,
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.MATERIALS, correction)

  const { data } = await axios.get(url)
  return data
}
export const getClassGradeAlgorithm = async ({ classId, userId }) => {
  const correction = {
    [':classId']: classId,
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.CLASS_GRADE_ALGORITHM, correction)

  const { data } = await axios.get(url)
  return data
}

export const getNotebook = async ({ classId, userId }) => {
  const correction = {
    [':classId']: classId,
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.NOTEBOOK, correction)

  const { data } = await axios.get(url)
  return data
}

export const getActivationAvailableNotebook = async (classId) => {
  const correction = {
    [':classId']: classId,
  }

  const url = autoReplace(
    ENDPOINTS_CLASSROOM.ACTIVATION_AVAILABLE_NOTEBOOK,
    correction
  )

  const { data } = await axios.get(url)
  return data
}

export const activateAdditio = async (classroomId) => {
  const url = `/bff-vle/teachers/class/${classroomId}/grader`
  const { data } = await axios.post(url)
  return data
}

export const feedbackActivateAdditio = async (classroomId) => {
  const url = `/bff-vle/classes/${classroomId}/feedback`
  const { data } = await axios.get(url)
  return data
}

export const getClassroomsByTeacherId = async (teacherId) => {
  const correction = {
    [':teacherId']: teacherId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TEACHER_CLASSES, correction)
  const { data } = await axios.get(url)
  return data
}

export const getGroupedClassesByTeacher = async (teacherId) => {
  const correction = {
    [':teacherId']: teacherId,
  }
  const url = autoReplace(
    ENDPOINTS_CLASSROOM.TEACHER_GROUPED_CLASSES,
    correction
  )
  const { data } = await axios.get(url)
  return data
}

export const getGroupedAvailableClassesByTeacher = async (teacherId) => {
  const correction = {
    [':teacherId']: teacherId,
  }
  const url = autoReplace(
    ENDPOINTS_CLASSROOM.TEACHER_GROUPED_AVAILABLE_CLASSES,
    correction
  )
  const { data } = await axios.get(url)
  return data
}

export const getAvailableClassesByTeacher = async ({ signal, teacherId }) => {
  const correction = {
    [':teacherId']: teacherId,
  }
  const url = autoReplace(
    ENDPOINTS_CLASSROOM.AVAILABLE_CLASSES_BY_TEACHER,
    correction
  )
  const { data } = await axios.get(url, { signal })
  return data
}

export const postReorderClassrooms = async ({
  teacherId,
  updateUserClasses,
}) => {
  const correction = {
    [':teacherId']: teacherId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.REORDER_CLASSES, correction)
  const { data } = await axios.post(url, { updateUserClasses })
  return data
}

export const postJoinClassrooms = async ({ classIds, teacherId }) => {
  const url = `/bk/teachers/${teacherId}/classes`
  const { data } = await axios.post(url, { classIds })
  return data
}

export const patchRenameClassroom = async ({ classId, name }) => {
  const correction = {
    [':classId']: classId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.RENAME_CLASS, correction)
  const { data } = await axios.patch(url, { name })
  return data
}

export const deleteClassroom = async ({ classId }) => {
  const correction = {
    [':classId']: classId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.DELETE_CLASS, correction)
  const { data } = await axios.delete(url)
  return data
}

export const getGradesByClassroomId = async (classroomId) => {
  checkError({ classroomId })
  const url = `/bk/classes/${classroomId}/grades`
  const { data } = await axios.get(url)
  return data
}

export const getQuestionsBySectionId = async (classroomId, sectionId) => {
  checkError({ classroomId, sectionId })
  const url = `/bk/resourceGrades/questions?classId=${classroomId}&sectionId=${sectionId}`
  const { data } = await axios.get(url)
  return data
}

export const sectionsByUnitId = async ({ classroomId, bookId, unitId }) => {
  checkError({ bookId, classroomId, unitId })
  const url = `/bk/resourceGrades/sections?classId=${classroomId}&bookId=${bookId}&unitId=${unitId}`
  const { data } = await axios.get(url)
  return data
}

export const getGradeAlgorithms = async () => {
  const url = ENDPOINTS_CLASSROOM.GRADE_ALGORITHMS
  const { data } = await axios.get(url)
  return data
}

export const patchGradeAlgorithms = async ({
  classId,
  gradeAlgorithmType,
  numberOfAttempt,
  showFeedback,
}) => {
  const url = ENDPOINTS_CLASSROOM.CLASSES_ID_GRADE_SYSTEM.replace(
    ':classId',
    classId
  )
  const { data } = await axios.patch(url, {
    gradeAlgorithmType,
    numberOfAttempt,
    showFeedback,
  })
  return data
}

export const getFeedBackResult = async (classId) => {
  const correction = {
    [':classId']: classId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.FEEDBACK_RESULT, correction)

  const { data } = await axios.get(url)
  return data
}

export const getAvailableClassesBySchool = async ({
  schoolCode,
  publicationId,
}) => {
  const correction = {
    [':publicationId']: publicationId,
    [':schoolCode']: schoolCode,
  }
  const url = autoReplace(
    ENDPOINTS_CLASSROOM.AVAILABLE_CLASSES_BY_SCHOOL,
    correction
  )

  const { data } = await axios.get(url)
  return data
}

export const postCreateClass = async ({
  publicationId,
  classroomId,
  className,
  teacherId,
}) => {
  const correction = {
    [':teacherId']: teacherId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.CREATE_CLASSES, correction)
  const { data } = await axios.post(url, {
    className,
    classroomId,
    publicationId,
  })
  return data
}

export const getClassesByStudent = async ({ studentId }) => {
  const correction = {
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.STUDENT_CLASSES, correction)
  const { data } = await axios.get(url)
  return data
}

export const getClassMembers = async ({
  classId,
  pageStudents,
  sizeStudents,
}) => {
  const correction = {
    [':classId']: classId,
    [':pageStudents']: pageStudents,
    [':sizeStudents']: sizeStudents,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.CLASS_MEMBERS, correction)
  const { data } = await axios.get(url)
  return data
}

export const getClassByStudent = async ({ classId, userId }) => {
  const correction = {
    [':classId']: classId,
    [':studentId']: userId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.STUDENT_CLASS, correction)
  const { data } = await axios.get(url)
  return data
}

export const getTeacherTasksByClassId = async ({
  classId,
  page,
  size,
  status,
  teacherId,
}) => {
  const correction = {
    [':classId']: classId,
    [':page']: page,
    [':size']: size,
    [':status']: status,
    [':teacherId']: teacherId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.CLASS_TEACHER_TASKS, correction)
  const { data } = await axios.get(url)
  return data
}

export const getStudentTasksByClassId = async ({
  classId,
  state,
  status,
  studentId,
}) => {
  const correction = {
    [':classId']: classId,
    [':state']: state,
    [':status']: status,
    [':studentId']: studentId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.STUDENT_TASKS, correction)
  const { data } = await axios.get(url)
  return data
}

export const patchActivateTask = async (taskId) => {
  const correction = {
    [':taskId']: taskId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK_ACTIVE, correction)
  const { data } = await axios.patch(url)
  return data
}

export const deleteTask = async (taskId) => {
  const correction = {
    [':taskId']: taskId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK, correction)
  const { data } = await axios.delete(url)
  return data
}

export const postCreateTask = async ({
  activities,
  classId,
  deleteResultsOption,
  description,
  endDate,
  externalMaterials,
  name,
  startDate,
  students,
  teacherId,
}) => {
  const url = ENDPOINTS_CLASSROOM.TASKS
  const { data } = await axios.post(url, {
    activities,
    classId,
    deleteResultsOption,
    description,
    endDate: dateToTimestamp(endDate),
    externalMaterials,
    name,
    startDate: dateToTimestamp(startDate),
    students,
    teacherId,
  })
  return data
}
export const patchUpdateTask = async ({
  activities,
  classId,
  deleteResultsOption,
  description,
  endDate,
  externalMaterials,
  name,
  startDate,
  students,
  taskId,
  teacherId,
}) => {
  const correction = {
    [':taskId']: taskId,
  }
  const task = {
    activities,
    classId,
    deleteResultsOption,
    description,
    endDate: endDate ? dateToTimestamp(endDate) : endDate,
    externalMaterials,
    name,
    startDate: startDate ? dateToTimestamp(startDate) : startDate,
    students,
    teacherId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK, correction)
  const { data } = await axios.patch(url, task)
  return data
}

export const patchUpdateTaskNotification = async (taskId, userId) => {
  const correction = {
    [':taskId']: taskId,
    [':userId']: userId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK_NOTIFICATION, correction)
  const { data } = await axios.patch(url)
  return data
}

export const getTask = async (taskId) => {
  const correction = {
    [':taskId']: taskId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK, correction)
  const { data } = await axios.get(url)
  return data
}

export const postCreateDrafTask = async ({
  activities,
  classId,
  description,
  endDate,
  externalMaterials,
  name,
  startDate,
  students,
  teacherId,
}) => {
  const url = ENDPOINTS_CLASSROOM.TASKS_DRAFT
  const { data } = await axios.post(url, {
    activities,
    classId,
    description,
    endDate: endDate ? dateToTimestamp(endDate) : EMPTY_STRING,
    externalMaterials,
    name,
    startDate: startDate ? dateToTimestamp(startDate) : EMPTY_STRING,
    students,
    teacherId,
  })
  return data
}

export const getSubmissionsList = async ({ page, size, taskId }) => {
  const correction = {
    [':page']: page,
    [':size']: size,
    [':taskId']: taskId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK_SUBMISSIONS, correction)
  const { data } = await axios.get(url)
  return data
}

export const patchCloseTask = async (taskId) => {
  const correction = {
    [':taskId']: taskId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK_CLOSE, correction)
  const { data } = await axios.patch(url)
  return data
}

export const getCheckResults = async ({
  activityIds,
  classId,
  studentsIds,
}) => {
  const correction = {
    [':activityIds']: activityIds,
    [':classId']: classId,
    [':studentsIds']: studentsIds,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK_RESULTS, correction)
  const { data } = await axios.get(url)
  return data
}

export const patchTaskStudentReview = async ({ taskId, studentId }) => {
  const correction = {
    [':studentId']: studentId,
    [':taskId']: taskId,
  }
  const url = autoReplace(ENDPOINTS_CLASSROOM.TASK_STUDENT_REVIEW, correction)
  const { data } = await axios.patch(url)
  return data
}
